/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClientNotificationDto } from './clientNotificationDto';


export interface ClientUserNotificationDto { 
    id?: number;
    created?: string;
    readAt?: string;
    sentAt?: string;
    status?: ClientUserNotificationDto.StatusEnum;
    notification?: ClientNotificationDto;
}
export namespace ClientUserNotificationDto {
    export type StatusEnum = 'PENDING' | 'SENT' | 'READ' | 'ERROR';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Sent: 'SENT' as StatusEnum,
        Read: 'READ' as StatusEnum,
        Error: 'ERROR' as StatusEnum
    };
}


